<template>
  <div class="page-wrap">
    <official-seal></official-seal>
    <Bottom></Bottom>
  </div>
</template>
<script>
import OfficialSeal from "./components/OfficialSeal.vue";
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
export default {
  components: { OfficialSeal, Bottom, Header },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
</style>
